import { useContext } from "preact/hooks";
import { NotificationContext } from "../notification-provider";
import Notification from "../notification";
import { ToastContainer } from "react-bootstrap";

const NotificationZone = () => {
    const { notifications, removeNotification } = useContext(NotificationContext);

    return (
        <ToastContainer className="p-3" position={`bottom-center`} style={{ zIndex: 9999999 }}>
            {notifications.map((notification, index) => (
                <Notification
                    index={index}
                    key={notification.id}
                    message={notification.message}
                    type={notification.type}
                    id={notification.id}
                    onRemove={removeNotification}
                />
            ))}
        </ToastContainer>
    );
};

export default NotificationZone;